define('logitail_promocodetaxupdatecart_promocodetaxupdatecart.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('logitail_promocodetaxupdatecart_promocodetaxupdatecart', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/logitail/PromoCodeTaxUpdateCart/1.0.0/', 'extensions/logitail/PromoCodeTaxUpdateCart/1.0.0/', Handlebars);
});